export const userGroupName = {
  methods: {
    userGroupName: function(item) {
      var groups = this.groups;
      var names = (item.id_groups || []).map(function(idGroup) {
              var group = groups.find(function(element) {
                  return element.id == idGroup;
              });
              return group ? group.name : undefined;
          }).filter(function(name) { return name; });
      if (names.length == 0) {
          return 'Grupo desconocido';
      }
      return names.join(', ');
    }
  }
}
